import { invalidateMaterialReports } from './useMaterialReports';
import { materialCostKeys } from './useMaterialCosts';
import { stockMovementKeys } from './useStockMovements';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from './apiClient';

export const articleStockKeys = {
  all: ['articleStocks'],
  byArticle: (articleId) => [...articleStockKeys.all, 'byArticle', articleId],
};

export const useArticleStocksByArticle = (articleId, options = {}) => {
  return useQuery({
    queryKey: articleStockKeys.byArticle(articleId),
    queryFn: async () => {
      const response = await apiClient.get(`article_stocks/by-article/${articleId}`);
      return response.data;
    },
    enabled: !!articleId,
    staleTime: 60 * 1000,
    ...options,
  });
};

export const useAdjustArticleStock = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload) => {
      const response = await apiClient.post('article_stocks/adjust', payload);
      return response.data;
    },
    onSuccess: (_data, variables) => {
      invalidateMaterialReports(queryClient);
      queryClient.invalidateQueries({ queryKey: materialCostKeys.all });
      if (variables?.uuid_inventory_article) {
        queryClient.invalidateQueries({
          queryKey: articleStockKeys.byArticle(variables.uuid_inventory_article),
        });
      }
      queryClient.invalidateQueries({ queryKey: stockMovementKeys.all });
    },
    onError: (error) => {
      console.error('Error adjusting article stock:', error);
    },
  });
};
